import React from 'react';
import Select, { components } from 'react-select';

const selectStyles = {
  container: provided => ({
    ...provided,
    border: 'none',
  }),
  option: (provided, state) => {
    return {
      ...provided,
      color: state.isSelected ? '#030d9c' : 'black',
      backgroundColor: 'transparent',
      padding: '10px 15px',
      cursor: 'pointer',
    };
  },
  menu: provided => ({
    ...provided,
    borderRadius: 0,
    padding: 0,
  }),
  menuList: provided => ({
    ...provided,
    maxHeight: '400px',
  }),
  dropdownIndicator: () => ({
    display: 'none',
  }),
  control: () => ({
    border: 'none',
  }),
  valueContainer: provided => ({
    ...provided,
    padding: '12px 0 14px',
    cursor: 'pointer',
    display: 'flex',
  }),
  singleValue: provided => ({
    ...provided,
    cursor: 'text',
    paddingRight: '20px',
    margin: 0,
  }),
  input: provided => ({
    ...provided,
    margin: 0,
  }),
  indicatorsContainer: () => ({
    display: 'none',
  }),
  multiValue: provided => ({
    ...provided,
    maxWidth: '90%',
    display: 'flex',
  }),
};

const MultiValue = props => {
  return <div className="select__multi-label">{props.data.label}</div>;
};

const Option = props => {
  return (
    <div>
      <components.Option {...props}>
        <div className="check__label">
          <input
            className="check__inp"
            type="checkbox"
            checked={props.isSelected}
          />
          <span className="check__box check__box--schedule" />
          <p className="check__text check__text--schedule">{props.label}</p>
        </div>
      </components.Option>
    </div>
  );
};

const CustomSelect = props => {
  const { value, label, onChange, options, isMulti, style } = props;
  const possibleLabel = options?.find(option => option.value === value)?.label || value;

  const multiValue = value?.map?.(val => ({
    value: val,
    label:
      value?.length > 1
        ? `${value?.length} выбрано`
        : options.find(option => option.value === val)?.label || '-',
  })) ?? { value, label: possibleLabel };
  
	const getIcon = () => {
    const {
      required,
      value,
      validator,
      error
    } = props;

    if(required){
      if(value){
        return <div className="select--success-icon" />;
      } else {
        return <div className="select--error-icon" />;
      };
    }
  }

  const getClasses = () => {
    const classes = ['select'];
    if(props.value){
      classes.push('select--filled')
    } else if(props.error){
      classes.push('select--error')
    }
    return classes.join(' ');
  }

  return (
    <div style={style} className={getClasses()}>
      <div className="select__label select__label-schedule">{label || ''}</div>
      <Select
        closeMenuOnSelect={!isMulti}
        isMulti={isMulti}
        classNamePrefix="react-select"
        styles={selectStyles}
        noOptionsMessage={() => 'Нет подходящих элементов'}
        hideSelectedOptions={false}
        value={multiValue}
        isSearchable={false}
        components={isMulti ? { Option, MultiValue } : { MultiValue }}
        // FIXME: onChange logic should be at component
        onChange={selectedInput => {
          if (!selectedInput?.length && selectedInput?.value) {
            return onChange([selectedInput.value]);
          }
          if (!selectedInput?.length) {
            return onChange(['All']);
          }
          if (
            !value.includes('All') &&
            selectedInput?.map(item => item.value).includes('All')
          ) {
            return onChange(['All']);
          }
          if (selectedInput?.length > 1) {
            const selected = selectedInput.filter(
              item => item.value?.toLowerCase() !== 'all',
            );
            return onChange(selected.map(item => item.value));
          } else {
            return onChange([selectedInput[0].value]);
          }
        }}
        options={options}
      />
      { getIcon() }
    </div>
  );
};

export default CustomSelect;
